// Copies before sorting: the list it receives is the shared React Query cache entry,
// and sorting it in place would reorder it for every other observer.
export const sortHubUsersCurrentFirst = <T extends { email?: string }>(
  users: T[],
  currentUserEmail: string | undefined,
): T[] => {
  // Without this, a viewer with no email would match every user whose email is also missing.
  if (!currentUserEmail) return [...users]

  return [...users].sort((a, b) => {
    if (a.email === currentUserEmail) return -1
    if (b.email === currentUserEmail) return 1
    return 0
  })
}
